import React from 'react'
import { object, array, string } from 'prop-types'

class GenericRichSnippets extends React.Component {
  getFeedData () {
    const { pageData: { pageName }, functionParams } = this.props
    let option = 'reviews'
    if (functionParams && functionParams[0]) {
      switch (functionParams[0]) {
        case 'percentage':
          option = 'scoreAsPercentage'
          break
      }
    }

    let data = { }
    try {
      if ((/airport-parking/).test(pageName)) {
        data = require('../../../../../config/exports/buildTimeOnly/reviews/parkingReviewsMeta.json')
      }
      if ((/airport-hotels/).test(pageName)) {
        data = require('../../../../../config/exports/buildTimeOnly/reviews/hotelReviewsMeta.json')
      }
      if ((/airport-lounges/).test(pageName)) {
        data = require('../../../../../config/exports/buildTimeOnly/reviews/loungeReviewsMeta.json')
      }
      if ((/insurance/).test(pageName)) {
        data = require('../../../../../config/exports/buildTimeOnly/reviews/insurance/meta/meta.json')
      }
    } catch (e) {
      // just return blank if error
    }
    if (!(data && data[option])) return false
    return data[option].toFixed(0).replace(/./g, function (c, i, a) {
      return i && c !== '.' && ((a.length - i) % 3 === 0) ? ',' + c : c
    })
  }

  render () {
    const { id } = this.props
    const data = this.getFeedData()
    if (!data) return null
    return <span id={id}>{ data }</span>
  }
}

GenericRichSnippets.propTypes = {
  id: string.isRequired,
  pageData: object.isRequired,
  functionParams: array
}

export default GenericRichSnippets



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/generic-rich-snips.jsx